
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/parenting-tired",
      function () {
        return require("private-next-pages/blog/parenting-tired.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/parenting-tired"])
      });
    }
  